import script from "./ModalSpinner.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalSpinner.vue?vue&type=script&setup=true&lang=js"

import "./ModalSpinner.vue?vue&type=style&index=0&id=6a56a035&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a56a035"]])

export default __exports__